import React from 'react';

import { GussetCreationDetails } from '../../dialogs/GussetCreationDetails';
import { useAppSelector } from '../../hooks';
import { BearingEnvelopeInsertionSubPanel } from '../subpanels/insertions/BearingEnvelopeInsertionSubPanel';
import { CeilingTrayInsertionSubPanel } from '../subpanels/insertions/CeilingTrayInsertionSubPanel';
import { ChordStackInsertionSubPanel } from '../subpanels/insertions/ChordStackInsertionSubPanel';
import { ComponentDesignInsertionSubPanel } from '../subpanels/insertions/component/ComponentDesignInsertionSubPanel';
import { DropTopChordsInsertionSubPanel } from '../subpanels/insertions/DropTopChordsInsertionSubPanel';
import { FeatureAreaInsertionSubPanel } from '../subpanels/insertions/FeatureAreaInsertionSubPanel';
import { FeaturePatternContainerInsertionSubPanel } from '../subpanels/insertions/FeaturePatternContainerInsertionSubPanel';
import JackGirderConnectionInsertion from '../subpanels/insertions/JackGirderConnectionInsertion';
import { LoadCaseInsertionSubPanel } from '../subpanels/insertions/LoadCaseInsertionSubPanel';
import LoadInsertionSubPanel from '../subpanels/insertions/LoadInsertionSubPanel';
import { MemberInsertionSubPanel } from '../subpanels/insertions/MemberInsertionPanel';
import MovingLoadSettingsInsertion from '../subpanels/insertions/MovingLoadSettingInsertion';
import ParapetWindLoadSettingsInsertion from '../subpanels/insertions/ParapetWindLoadSettingsInsertion';
import { CeilingPlaneInsertionSubPanel } from '../subpanels/insertions/planes/CeilingPlaneInsertionSubPanel';
import { RoofPlaneInsertionSubPanel } from '../subpanels/insertions/planes/RoofPlaneInsertionSubPanel';
import PlatePairInsertionSubPanel from '../subpanels/insertions/PlatePairInsertionSubPanel';
import { ReferenceLineInsertionSubPanel } from '../subpanels/insertions/ReferenceLineInsertionPanel';
import { CornerSetInsertionSubPanel } from '../subpanels/insertions/truss-envelope/CornerSetInsertionSubPanel';
import { RunInsertionSubPanel } from '../subpanels/insertions/truss-envelope/RunInsertionSubPanel';
import { TrussEnvelopeInsertionSubPanel } from '../subpanels/insertions/truss-envelope/TrussEnvelopeInsertionSubPanel';
import { WorkLineInsertionSubPanel } from '../subpanels/insertions/truss-envelope/WorkLineInsertionSubPanel';
import { TrussGroupInsertionPanel } from '../subpanels/insertions/TrussGroupInsertionPanel';

export default function InsertionPanel() {
  const insertingObjectInfo = useAppSelector((state) => state.application.insertingObjectInfo);

  switch (insertingObjectInfo?.type) {
    case 'bearingEnvelope':
      return <BearingEnvelopeInsertionSubPanel />;
    case 'ceilingPlane':
      return <CeilingPlaneInsertionSubPanel />;
    case 'ceilingTray':
      return <CeilingTrayInsertionSubPanel />;
    case 'componentDesign':
      return <ComponentDesignInsertionSubPanel />;
    case 'cornerSet':
      return <CornerSetInsertionSubPanel />;
    case 'droppedTopChords':
      return <DropTopChordsInsertionSubPanel />;
    case 'featureArea':
      return <FeatureAreaInsertionSubPanel />;
    case 'featurePatternContainer':
      return <FeaturePatternContainerInsertionSubPanel />;
    case 'gusset':
      return <GussetCreationDetails />;
    case 'jackGirderConnection':
      return <JackGirderConnectionInsertion />;
    case 'load':
      return <LoadInsertionSubPanel />;
    case 'loadCase':
      return <LoadCaseInsertionSubPanel />;
    case 'member':
      return <MemberInsertionSubPanel />;
    case 'memberStack':
      return <ChordStackInsertionSubPanel />;
    case 'movingLoadSettings':
      return <MovingLoadSettingsInsertion />;
    case 'parapetLoadSettings':
      return <ParapetWindLoadSettingsInsertion />;
    case 'platePair':
      return <PlatePairInsertionSubPanel />;
    case 'referenceLine':
      return <ReferenceLineInsertionSubPanel />;
    case 'roofPlane':
      return <RoofPlaneInsertionSubPanel />;
    case 'trussEnvelope':
      return <TrussEnvelopeInsertionSubPanel />;
    case 'trussEnvelopeRun':
      return <RunInsertionSubPanel />;
    case 'trussGroup':
      return <TrussGroupInsertionPanel />;
    case 'workLine':
      return <WorkLineInsertionSubPanel />;

    default:
      return null;
  }
}
